import { render, staticRenderFns } from "./provider-search.vue?vue&type=template&id=07857754"
import script from "./provider-search.vue?vue&type=script&lang=ts"
export * from "./provider-search.vue?vue&type=script&lang=ts"
import style0 from "./provider-search.vue?vue&type=style&index=0&id=07857754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports